import type { FeatureEvents, TrackEvent } from '../new-analytics-types';
import { TrackAction, TrackActionSubject } from '../new-analytics-types';

type TrackKeys = 'rovoConnectorSetupInitiated' | 'rovoConnectorSetupCompleted' | 'rovoConnectorSetupFailed';

export const rovoConnectorSetupScreen = 'rovoConnectorSetupScreen';

export const rovoOnboardingEvents: FeatureEvents<string, string, TrackKeys, string> = {
  confluenceSpec:
    'https://hello.atlassian.net/wiki/spaces/~712020ede5b79bbc0243e693beec0d32201212/pages/5546547106/Project+Poster+Gamified+Onboarding+for+3P+Connectors#Success-Criteria',

  screen: {},
  ui: {},

  track: {
    rovoConnectorSetupInitiated: (attributes: { source: string }): TrackEvent => ({
      data: {
        action: TrackAction.Started,
        actionSubject: TrackActionSubject.RovoConnectorSetup,
        source: attributes.source,
      },
      dataPortalLink: 'https://data-portal.internal.atlassian.com/analytics/registry/91549',
    }),

    rovoConnectorSetupCompleted: (attributes: { source: string }): TrackEvent => ({
      data: {
        action: TrackAction.Completed,
        actionSubject: TrackActionSubject.RovoConnectorSetup,
        source: attributes.source,
      },
      dataPortalLink: 'https://data-portal.internal.atlassian.com/analytics/registry/91641',
    }),

    rovoConnectorSetupFailed: (attributes: { source: string }): TrackEvent => ({
      data: {
        action: TrackAction.Canceled,
        actionSubject: TrackActionSubject.RovoConnectorSetup,
        source: attributes.source,
      },
      dataPortalLink: 'https://data-portal.internal.atlassian.com/analytics/registry/91550',
    }),
  },

  operational: {},
};
